export default "__VITE_ASSET__BOtQq1dp__"